import React, { useMemo } from 'react'
import { EnviromentalSafeguardsData } from '../GeneralInformation/typesExtendedReport'

export const useEnvSafeguardsData = (data: EnviromentalSafeguardsData | null | undefined) => {

    return useMemo(() => {
        if (!data) return null;

        return {
            EsgDistributionAccording: data.esgDistributionAccording,
            EsgEnvironmentalSocialRiskRating: data.esgEnvironmentalSocialRiskRating,
            EsgSafeGuardPerformanceRatingSocial: data.esgSafeGuardPerformanceRatingSocial,
            ProjectsMICI: data.projectsMICI,
        }
    }, [data])
}